export enum Tabs {
  MY_LEADS = 'MY_LEADS',
  SCRAPEKING_DB = 'SCRAPEKING_DB',
  PIPELINE = 'PIPELINE',
}
